
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { userModule } from '@/store/modules/user';
import LangFlag from 'vue-lang-code-flags';


@Component({
  components: {
    LangFlag
  }
})
export default class App extends Vue {
  get signedIn() {
    return userModule.isSignedIn;
  }

  get user() {
    return userModule.user;
  }

  private dialog = false;
  private mini = false;
  private dialogText = '';
  private dialogTitle = '';
  private isRootComponent = true;
  public drawer = window.innerWidth > 960;
  private fixed = false;
  private items: AppMenu[] = [
    {
      //icon: 'mdi-point-of-sale',
      title: 'Flotas',
      vertical: 'Flotas',
      link: 'flotas',
      role: 'user'
    },
    {
      //icon: 'mdi-point-of-sale',
      title: 'Usuarios',
      vertical: 'Usuarios',
      link: 'usuarios',
      role: 'admin'
    },
    {
      //icon: 'mdi-point-of-sale',
      title: 'Importar neumáticos',
      vertical: 'Importar neumáticos',
      link: 'importar-neumaticos',
      role: 'admin'
    }
  ];

  private userMenus: AppMenu[]  = [
    {
      //icon: 'bubble_chart',
      title: 'Logout',
      link: 'login'
    },
    /*{
      //icon: 'bubble_chart',
      title: 'Change Password',
      link: 'changepassword'
    }*/
  ];

  private miniVariant = false;
  private right = true;
  private rightDrawer = false;
  private menuItem = '';
  private tiposInformes= [];
  private langs= ['es', 'fr'];

  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, _from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      
      //  start the progress bar
      this.$Progress.start();

      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      if (to.name !== 'ErrorPage') {
        this.menuItem = to.name;
      }
      //  finish the progress bar
      this.$Progress.finish();
    });
  
  }

  get activeMenuItem() {
    return this.menuItem;
  }

  handleNavigtiion(item: TODO) {
    console.log(item.link);
    this.menuItem = item.title;
    this.$router.push({
      path: '/'+item.link
    });
  }

  async handleUserActions(item: TODO) {
    this.menuItem = item.title;
    if (item.title === 'Logout') {
      await userModule.logout();
    }
    this.$router.push('/'+item.link);
  }

  changeLanguage(language){
    this.$i18n.locale= language;
    sessionStorage.setItem("language", language);
  }

  mounted() {
    console.log(this.$t("message.Calendario inspecciones"));
    this.tiposInformes= [
      {title: this.$t("Calendario inspecciones"),
        link: 'informes/calendario_inspeccion_vehiculo'},
      {title: this.$t("Informes de trabajo"),
        link: 'informes/extraccion_informes_trabajo'},
        {title: this.$t("Informe inspecciones"),
        link: 'informes/informe_inspecciones'},
      {title: 'Fleet service request',
        link: 'informes/reporte_flota'},
      {title: this.$t("Informe neumático"),
        link: 'informes/informe_neumatico'},
      {title: this.$t("Informe neumático por vehículo"),
        link: 'informes/informe_neumatico_vehiculo'},
      /*{title: 'Informe de vehículos pendientes de inspección',
        link: 'informes/informe_pendientes_inspeccion'},*/
    ];
  }
}
